// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.header {\n  display: flex;\n  font-size: 16px;\n  font-family: \"Helvetica\", \"Arial\", \"Verdana\", sans-serif;\n}\ndiv.header header .MuiToolbar-gutters {\n  padding-left: 16px;\n}\ndiv.header header .hd-title {\n  flex-grow: 1;\n}\n.navItems {\n  display: flex;\n}\n.navItems .navTitle {\n  padding-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
